module.exports = __webpack_public_path__ + "static/media/bullet-hole-2.10d3341b.svg";